export default __webpack_public_path__ + "static/media/whyVisit1.32670373.svg";